import { render, staticRenderFns } from "./salesProjectCreate.vue?vue&type=template&id=188bd2ee&scoped=true&"
import script from "./salesProjectCreate.vue?vue&type=script&lang=js&"
export * from "./salesProjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./salesProjectCreate.vue?vue&type=style&index=0&id=188bd2ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188bd2ee",
  null
  
)

export default component.exports